import * as Sentry from "@sentry/react"
import i18next, { PostProcessorModule } from "i18next"
import config from "lib/config"
import { initReactI18next } from "react-i18next"
import { Errors, Locale } from "schema"
import "virtual:i18next-loader"

import enUS from "../translations/en-US"
import esES from "../translations/es-ES"

const DEFAULT_LOCALE = "en-US"

const i18n = i18next

// TODO: Locales should be loaded async.
export function setupI18n(customPlugin: PostProcessorModule) {
  // The Permut widget embedded in the app reads its locale from <html lang>.
  i18n.on("languageChanged", (language) => {
    document.documentElement.lang = language
  })

  i18n.use(initReactI18next).init({
    lng: navigator.language ?? DEFAULT_LOCALE,
    debug: config.isDevelopment,
    // NOTE: Fallback can have a complex logic. Add it when we have more languages
    fallbackLng: DEFAULT_LOCALE,
    resources: {
      "en-US": {
        translation: enUS,
      },
      "es-ES": {
        translation: esES,
      },
    },
    saveMissing: true,
    missingKeyHandler: (_lngs, _ns, key) => {
      Sentry.captureException(`Missing translation key: ${key}`)
      if (config.isDevelopment) {
        console.error(`Missing translation key: ${key}`)
      }
    },
    postProcess: ["customProcessor"],
    interpolation: {
      escapeValue: false,
    },
  })

  if (location.hash === "#dev-lang") {
    i18n.use(customPlugin)
  }
}

type ErrorTranslations = Record<Errors, string>

export function getErrorTranslations(): ErrorTranslations {
  return i18n.t("errors", { returnObjects: true }) as ErrorTranslations
}

export function updateI18n(locale: keyof typeof Locale) {
  i18n.changeLanguage(convertLocale(locale))
}

function convertLocale(locale: keyof typeof Locale) {
  switch (locale) {
    case "en_US":
      return "en-US"
    case "es_ES":
      return "es-ES"
    default:
      return DEFAULT_LOCALE
  }
}
